import HttpService from "./http.service";

const qs = (filtros = {}) =>
  new URLSearchParams(Object.entries(filtros).filter(([, v]) => v)).toString();

class FinanceiroService {
  // { dataInicio, dataFim (AAAA-MM-DD), account, empresa }
  movimentacao = async (filtros) =>
    await HttpService.get(`/financeiro/movimentacao?${qs(filtros)}`);

  // movimentos: [{ id, account }]
  conciliar = async (movimentos, conciliado = true, dataConciliacao = null) =>
    await HttpService.post("/financeiro/conciliacao", {
      movimentos,
      conciliado,
      dataConciliacao,
    });

  // Relatório de divergências (só leitura)
  divergencias = async () => await HttpService.get("/financeiro/divergencias");

  // Fechamento do período (data até a qual o realizado fica travado)
  fechamento = async () => await HttpService.get("/financeiro/fechamento");

  alterarFechamento = async (data, motivo = "") =>
    await HttpService.put("/financeiro/fechamento", { data, motivo });

  // Extrato OFX
  importarOfx = async (arquivo, account, usarSaldo = true) => {
    const form = new FormData();
    form.append("arquivo", arquivo);
    form.append("account", account);
    form.append("usarSaldo", String(usarSaldo));
    return await HttpService.postFile("/financeiro/extrato/importar", form);
  };

  extrato = async (filtros) =>
    await HttpService.get(`/financeiro/extrato?${qs(filtros)}`);

  candidatos = async (id) =>
    await HttpService.get(`/financeiro/extrato/${id}/candidatos`);

  conciliarLinha = async (id, movimentoId) =>
    await HttpService.post(`/financeiro/extrato/${id}/conciliar`, {
      movimentoId,
    });

  lancarLinha = async (id, dados) =>
    await HttpService.post(`/financeiro/extrato/${id}/lancar`, dados);

  ignorarLinha = async (id, ignorar = true) =>
    await HttpService.post(`/financeiro/extrato/${id}/ignorar`, { ignorar });

  desfazerLinha = async (id) =>
    await HttpService.post(`/financeiro/extrato/${id}/desfazer`, {});

  lancamentos = async (filtros) =>
    await HttpService.get(`/financeiro/lancamentos?${qs(filtros)}`);

  criarLancamento = async (data) =>
    await HttpService.post("/financeiro/lancamentos", data);

  atualizarLancamento = async (id, data) =>
    await HttpService.put(`/financeiro/lancamentos/${id}`, data);

  excluirLancamento = async (id) =>
    await HttpService.delete(`/financeiro/lancamentos/${id}`);
}

export default new FinanceiroService();
